/**
 * PDF görüntüleyici — fatura PDF'i panelden çıkmadan.
 *
 * Neden kütüphane yok: tarayıcının kendi PDF görüntüleyicisi (yakınlaştırma,
 * arama, yazdırma) `<iframe>` içinde gelir; pdf.js eklemek 1 MB'lık paket ve
 * bakım demek. Sunucu PDF'i `inline` verdiği için iframe doğrudan gösterir;
 * çerez aynı kökende olduğu için yetki kontrolü de aynen çalışır.
 *
 * Görüntüleyici gömülüyse "yeni sekmede aç" ve "indir" yine sunulur — mobil
 * tarayıcıların bir kısmı iframe'de PDF çizmez; kullanıcı kapalı kalmasın.
 */

import { Download, ExternalLink } from 'lucide-react';
import { Pencere } from './ui/Pencere';
import { Dugme } from './ui/Dugme';

export interface PdfGoruntuleyiciProps {
  /** `inline` PDF adresi (aynı köken). */
  adres: string;
  baslik: string;
  altBaslik?: string | undefined;
  onKapat: () => void;
}

export function PdfGoruntuleyici({ adres, baslik, altBaslik, onKapat }: PdfGoruntuleyiciProps) {
  const indirmeAdresi = `${adres}${adres.includes('?') ? '&' : '?'}indir=1`;

  return (
    <Pencere
      acik
      genis
      baslik={baslik}
      {...(altBaslik ? { aciklama: altBaslik } : {})}
      onKapat={onKapat}
      altCubuk={
        <div className="flex flex-wrap items-center gap-2">
          <a href={indirmeAdresi}>
            <Dugme gorunum="birincil" ikon={<Download size={15} />}>
              İndir
            </Dugme>
          </a>
          <a href={adres} target="_blank" rel="noreferrer">
            <Dugme gorunum="ikincil" ikon={<ExternalLink size={15} />}>
              Yeni sekmede aç
            </Dugme>
          </a>
          <Dugme gorunum="sessiz" onClick={onKapat} className="ml-auto">
            Kapat
          </Dugme>
        </div>
      }
    >
      {/*
        Yükseklik görünür alana bağlı (dvh): sabit px bir dizüstünde taşar, bir
        masaüstünde boş kalır. Genişlik kabı doldurur.
      */}
      <iframe
        src={adres}
        title={baslik}
        className="h-[70dvh] w-full rounded-[var(--radius-md)] border border-[var(--line)] bg-[var(--surface-sunken)]"
      />
      <p className="mt-2 text-xs text-[var(--ink-faint)]">
        Görüntülenmiyorsa tarayıcınız gömülü PDF desteklemiyordur — “Yeni sekmede aç”ı kullanın.
      </p>
    </Pencere>
  );
}
